import React, { useEffect, useState, useRef } from 'react';
import { Carousel } from 'react-responsive-carousel';

import {
	BackwardCarousel,
	ForwardCarousel,
	SendIconButton,
	WhiteTick,
} from '../../../../Components/FeatureComponents/Buttons/IconButton/Icons';
import Tooltip from '@mui/material/Tooltip';
import { getImg } from '../../../../Utils/getImg';
import {
	getCurrencySymbol,
	loadStateSession,
} from '../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';

type Props = {
	// 	handleSubmit: Function;
	// 	WorkflowData: any;
	colorMode: string;
	colorScale: string;
	data: any;
	selectProduct: Function;
	handleSelected: Function;
	tenantId;
	token;
	// 	botId: any;
	// 	conversationId: any;
	// 	cssPtag?: any;
	// 	addUserResponse: Function;
	// 	currentWorkflow: string;
	// 	changeScreen?: Function;
	// 	showToaster?: Function;
	// 	disableMandatory?: Function;
	// 	shouldDisableActions?;
};

const ProductCarousel = ({
	// handleSubmit,
	// WorkflowData,
	colorMode,
	colorScale,
	data,
	selectProduct,
	handleSelected,
	tenantId,
	token,
}: // botId,

// conversationId,
// cssPtag,
// changeScreen,
// addUserResponse,
// currentWorkflow,
// showToaster,
// disableMandatory,
// shouldDisableActions
Props) => {
	const [selected, handleSelect] = useState(0);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [llmproducts, setLLMProducts] = useState([]);

	const displaySymbol = (currencyCode) => {
		return <>{getCurrencySymbol(currencyCode)}</>;
	};

	useEffect(() => {
		console.log('data', data);
		let productIdsArray = data.map((eachItem, index) => {
			return eachItem.productId;
		});
		let stringifyProductIDs = String(productIdsArray);
		stringifyProductIDs &&
			Axios.get(
				`${
					window['BASE_URL']
				}/shop/${tenantId}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
					'FS-countryCode'
				)}`,
				{
					headers: {
						'x-tenant-id': tenantId,
						Authorization: `Bearer ${token}`,
					},
				}
			).then((resp: any) => {
				let response = resp.data.response;
				let products = response.data.products;
				setLLMProducts(products);
			});
	}, []);
	useEffect(() => {}, [llmproducts]);

	const productContentFullscreen = (item, index) => {
		let price = llmproducts.length
			? llmproducts.filter(
					(v) => v.id === (item.productId || item.product_id)
			  )[0].price
			: '';
		let currency =
			llmproducts.length &&
			llmproducts.filter((v) => v.id === (item.productId || item.product_id))[0]
				.currency;

		return (
			<>
				<div
					className={`ff-product-carousel-item ${
						selected == index ? 'selected' : ''
					} ${colorMode}`}
					onClick={() => {
						selectProduct(item.productId, item.title);
						handleSelect(index);
						handleSelected(index);
					}}
				>
					<img
						src={
							item.resourceURL.length > 0
								? item.resourceURL
								: getImg('icons/no-image.png')
						}
						style={{
							objectFit: item.resourceURL.length > 0 ? 'cover' : 'scale-down',
						}}
					/>
					{selected == index && (
						<div className='ff-selected-tick'>
							<WhiteTick />
						</div>
					)}
					<div className='ff-product-carousel-desc'>
						<div>
							<div>{item.title}</div>
						</div>
						{price !== '0' && (
							<div>
								{displaySymbol(currency)} <s></s>
								{price}
							</div>
						)}
					</div>
				</div>
			</>
		);
	};
	return (
		<div className='ff-product-carousel'>
			<Carousel
				onChange={(index) => {
					setCurrentIndex(index);
				}}
				showStatus={false}
				swipeable={true}
				showIndicators={false}
				showArrows={data.length > 2 ? true : false}
				showThumbs={false}
				centerMode={true}
				centerSlidePercentage={80}
				onSwipeEnd={(event) => {
					console.log(event);
				}}
				renderArrowNext={(onClickHandler, hasNext) =>
					data.length > 2 &&
					currentIndex != data.length - 1 && (
						<button
							className={`carouselButtons clickable right ${colorMode} `}
							onClick={onClickHandler}
							style={{
								top: '31%',
								right: '6px',
								boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.28)',
							}}
						>
							{/* <ArrowRight /> */}
							<ForwardCarousel
								fill={
									colorMode === 'dark' ? 'var(--selectedColor)' : colorScale[2]
								}
							/>
						</button>
					)
				}
				renderArrowPrev={(onClickHandler, hasPrev) =>
					data.length > 2 &&
					currentIndex !== 0 && (
						<button
							className={`carouselButtons clickable left ${colorMode}`}
							onClick={onClickHandler}
							style={{
								top: '31%',
								left: '24px',
								boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.28)',
							}}
						>
							{/* <ArrowLeft /> */}
							<BackwardCarousel
								width='24px'
								height='24px'
								fill={
									colorMode === 'dark' ? 'var(--selectedColor)' : colorScale[2]
								}
							/>
						</button>
					)
				}
			>
				{data.map((item, index) => {
					return productContentFullscreen(item, index);
				})}
			</Carousel>
		</div>
	);
};

export default ProductCarousel;
